import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ButtonPrimary } from '../../../../utils/Button';
import InputField from '../../../../utils/InputField';
import { useForgotPassword } from '../ForgottenProvider';

function EmailCont() {
    const { formData, handleChange, handleSendOtp, loadingEmail } = useForgotPassword();
    // Focus on Input Field
    useEffect(() => {
        document.getElementsByTagName('input')[0].focus();
    }, []);

    return (
        <div className="h-[calc(100vh_-_60px)] md:h-screen w-screen flex items-center justify-center bg-transparent px-4 relative">
            <form
                onSubmit={handleSendOtp}
                className="w-[430px] shadow-[0px_4px_50px_0px_rgba(4,43,58,0.03)] mx-auto flex flex-col justify-between items-center gap-y-4 bg-white p-8 lg:p-16  rounded-20 md:rounded-30"
            >
                <div className="w-full">
                    <h1 className="text-base font-medium text-primary-700">
                        <span className="inline-block border-b border-secondary leading-8">
                            Forgot
                        </span>
                        &nbsp;Password
                    </h1>
                </div>

                <InputField
                    name="Email"
                    placeholder="Email Address"
                    formData={formData}
                    onChange={handleChange}
                    height="h-10"
                    disabled={loadingEmail}
                />
                <div className="flex justify-between items-center w-full">
                    <span className="text-sm text-primary-700">
                        <Link
                            to="/login"
                            className="inline-block border-b border-secondary leading-8"
                        >
                            Back to Login
                        </Link>
                    </span>
                    <ButtonPrimary title="Send OTP" btnType="submit" loading={loadingEmail} />
                </div>
            </form>
        </div>
    );
}

export default EmailCont;
